module.exports = __webpack_public_path__ + "media/images/clearview-logo-sm-b74c889d5c5063a130bc33bc71491d3b.png";